import { QURE_AIRA_CREATOR_EMAIL } from "@/constants/aira";
/** Returns true when a reminder was generated by Aira (created by the Qure Aira system account). */
export function isAiraReminder(reminder) {
  var _reminder$created_by_;
  return ((_reminder$created_by_ = reminder.created_by_info) === null || _reminder$created_by_ === void 0 ? void 0 : _reminder$created_by_.email) === QURE_AIRA_CREATOR_EMAIL;
}